export class Category{
    id : string
    status : string
    title : Map<string,string>
    iconIds :  Map<string,string>
    productIds : Array<string>
    technicalAttributeIds : Array<string>
    priority : number
}